import { render, staticRenderFns } from "./MultiTable.vue?vue&type=template&id=3a84ab3a&scoped=true"
import script from "./MultiTable.vue?vue&type=script&lang=js"
export * from "./MultiTable.vue?vue&type=script&lang=js"
import style0 from "./MultiTable.vue?vue&type=style&index=0&id=3a84ab3a&prod&lang=scss&scoped=true"
import style1 from "./MultiTable.vue?vue&type=style&index=1&id=3a84ab3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84ab3a",
  null
  
)

export default component.exports